import type { HausratGebaeudedaten } from '../../interfaces';
import type { GebaeudedatenStepForms } from './gebaeudedaten-form.service';

export const mapGebaeudedatenToDto = (value: GebaeudedatenStepForms): HausratGebaeudedaten => ({
  gebaeudetyp: value.step3.gebaeudetyp,
  adresse: value.step4,
  // Listed field by field rather than spread: a spread escapes the excess-property check and
  // would put step5's UI-only `staendigBewohnt` on the wire.
  nutzungsflaeche: {
    wohnflaecheOhneKeller: value.step5.wohnflaecheOhneKeller,
    kellerVorhanden: value.step5.kellerVorhanden,
    // Without a Keller the two areas are never asked for, so send nothing rather than a zero.
    gesamtflaecheImKeller: value.step5.kellerVorhanden ? value.step5.gesamtflaecheImKeller : null,
    wohnflaecheImKeller: value.step5.kellerVorhanden ? value.step5.wohnflaecheImKeller : null,
  },
  bauartklasseFertighausgruppe: value.step6,
});
